var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ourservice-btn mybutton",on:{"click":function($event){return _vm.toRouter('/service')}}},[_c('img',{attrs:{"src":require('/src/assets/img/right-arrow.png')}}),_c('span',[_vm._v("Our Service")])])
}
var staticRenderFns = []

export { render, staticRenderFns }